import useSWR, { mutate } from 'swr';
import { useMemo } from 'react';
// utils
import axios, { fetcher, endpoints } from 'src/utils/axios';

export function useGetOffices() {
  const URL = endpoints.office.list;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, {
    shouldRetryOnError: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });
  const response = data?.data;
  const memoizedValue = useMemo(
    () => ({
      offices: response?.offices || [],
      officesLoading: isLoading,
      officesError: error,
      officesValidating: isValidating,
      officesEmpty: !isLoading && !response?.offices?.length,
    }),
    [response?.offices, error, isLoading, isValidating]
  );

  return memoizedValue;
}
export function useGetCityManagerUsers() {
  const URL = endpoints.office.getUserByRoleName;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcher, {
    shouldRetryOnError: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });
  const response = data?.data;
  const memoizedValue = useMemo(
    () => ({
      users: response?.users || [],
      usersLoading: isLoading,
      usersError: error,
      usersValidating: isValidating,
      usersEmpty: !isLoading && !response?.users?.length,
    }),
    [response?.users, error, isLoading, isValidating]
  );

  return memoizedValue;
}

export async function createOffice(apiData) {
  const URL = endpoints.office.list;

  try {
    const { data } = await axios.post(endpoints.office.create, apiData);
    if (data.code === 200) {
      await mutate(URL);
    }
    return data;
  } catch (error) {
    console.error('Error creating office:', error);
    throw error;
  }
}

export async function updateOffice(apiData) {
  const URL = endpoints.office.list;
  try {
    const { data } = await axios.put(endpoints.office.update, apiData);
    if (data.code === 200) {
      await mutate(URL);
    }
    return data;
  } catch (error) {
    console.error('Error creating office:', error);
    throw error;
  }
}

export async function deleteOffice(officeId) {
  const URL = endpoints.office.list;

  try {
    const { data } = await axios.delete(`${endpoints.office.delete}/${officeId}`);
    if (data.code === 200) {
      mutate(
        URL,
        (currentData) => {
          const currentOffices = currentData?.data?.offices || [];
          const updatedOffices = currentOffices.filter((office) => office._id !== officeId);
          return {
            ...currentData,
            data: updatedOffices
          };
        },
        false
      );
    }

    return data;
  } catch (error) {
    console.error('Error deleting office:', error);
    throw error;
  }
}